import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useTranslations } from 'next-intl';

import {
  ClearableNumberInputWithFrame,
  showClearButtonWhenValueIsNotZero,
} from '@flipster/features/src/input/clearable-number-input';
// ROLLBACK(last-price): trigger price type 셀렉터 재활성화 시 복원.
// import { TriggerPriceTypeSelect } from '@flipster/features/src/shared/trigger-price-type-select';
import { css } from '@flipster/styled-system/css';
import { stack, vstack } from '@flipster/styled-system/patterns';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';
import PriceRateButtons from '@web/components/PriceRateButtons';

import OrderPriceForm from './OrderPriceForm';
import { formBunja } from './bunja/form';
import { priceFormSegmentBunja } from './bunja/price-form';

const TriggerPriceList = ['-5', '-1', '+1', '+5'];

const TriggerPriceForm = () => {
  const transTrade = useTranslations('Trade.r250401');
  const { symbolInfoWithDefaultAtom } = useBunja(tradeSymbolBunja);
  const symbolInfo = useAtomValue(symbolInfoWithDefaultAtom);
  // ROLLBACK(last-price): 셀렉터 재활성화 시 triggerPriceTypeAtom 바인딩 복원.
  // const { triggerPriceAtom, triggerPriceTypeAtom, handleTriggerPricePercentAtom } = useBunja(formBunja);
  // const [triggerPriceType, setTriggerPriceType] = useAtom(triggerPriceTypeAtom);
  const { triggerPriceAtom, handleTriggerPricePercentAtom } = useBunja(formBunja);
  const [triggerPrice, setTriggerPrice] = useAtom(triggerPriceAtom);
  const handleTriggerPricePercent = useSetAtom(handleTriggerPricePercentAtom);
  const { trackTabPriceClearClick, trackTabPriceEditClick } = useBunja(priceFormSegmentBunja);

  const { pricePrecision, quoteCurrency } = symbolInfo;

  return (
    <div className={vstack({ w: '100%', gap: 16, py: 16, alignItems: 'stretch' })}>
      <div className={vstack({ w: '100%', gap: 8, alignItems: 'stretch' })}>
        <div className={css({ textStyle: 'Text/L/Strong' })}>{transTrade('Trigger_price')}</div>
        <div className={stack({ gap: 8, w: 'full' })}>
          <ClearableNumberInputWithFrame
            determineShowClearButton={showClearButtonWhenValueIsNotZero}
            value={triggerPrice}
            precision={pricePrecision}
            // ROLLBACK(last-price): 셀렉터 재활성화 시 currency를 제거하고 suffix 셀렉터로 교체.
            currency={quoteCurrency}
            onChange={(p) => setTriggerPrice(p || '0')}
            onFocus={trackTabPriceEditClick}
            onClearClick={trackTabPriceClearClick}
            // suffix={
            //   <TriggerPriceTypeSelect value={triggerPriceType} onChange={setTriggerPriceType} placement='in-input' />
            // }
          />
          <PriceRateButtons
            items={TriggerPriceList}
            onClick={(e) => handleTriggerPricePercent(e.currentTarget.value)}
          />
        </div>
      </div>
      <OrderPriceForm />
    </div>
  );
};

export default TriggerPriceForm;
